import { useSelector } from "react-redux";
import BtnGroup from "./BtnGroup";
import Tag from "../Tag";

const DetailedPost = ({ blog }) => {
    const { updatedBlog } = useSelector((state) => state.likeSaved);

    const { id, title, description, image, tags, likes, isSaved } =
        updatedBlog?.id ? updatedBlog : blog || {};

    return (
        <main className="post">
            <img
                src={image}
                alt={title}
                className="w-full rounded-md"
                id="lws-megaThumb"
            />

            <div>
                <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
                    {title}
                </h1>

                <div className="tags" id="lws-singleTags">
                    {tags?.map((tag, i) => (
                        <Tag
                            key={i}
                            tag={tag}
                            index={i}
                            length={tags?.length}
                        />
                    ))}
                </div>

                <BtnGroup blogId={id} likes={likes} isSaved={isSaved} />

                <div className="mt-6">
                    <p>{description}</p>
                </div>
            </div>
        </main>
    );
};

export default DetailedPost;
